import PropTypes from "prop-types";
import React from "react";

// @material-ui/core components
import { withStyles } from "@mui/styles";
import { Card, CardBody, Button, GridContainer, GridItem } from "~/shared/components/MuiComponents.jsx";

import consultationStyles from "../styles/consultationStyles.js";

import { trackVisitProductSelected } from "../utils/analytics.js";

import imgOnePack from "~assets/images/visits/one-pack.png";
import imgTwoPack from "~assets/images/visits/two-pack.png";

import {
  getVisitID,
  getVisitProduct,
  isFollowUpVisit,
  setConsultationTypeOrderItem,
  setVisitProduct,
} from "~/visits/utils/visitCookies";

import {
  COLOR_KICK_BLUE,
  ORDER_TYPE_PROP_1_PACK,
  ORDER_TYPE_PROP_1_PACK_FOLLOW_UP,
  ORDER_TYPE_PROP_2_PACK,
  ORDER_TYPE_PROP_2_PACK_FOLLOW_UP,
} from "~/shared/sharedConstants.js";

import { kickBlue, kickNavy, kickRed } from "~/shared/styles/baseStyles";
import { isMailOrderBBOrderType } from "~/shared/utils/sharedUtils";

import {
  getBBProductDetails,
  getFollowUpOrOriginalPrice,
} from "./payment/paymentHelpers.js";

class SelectBBProduct extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(this.props.location.search);
    const checkoutSessionID = queryParams.get("checkoutSessionID");
    if (!checkoutSessionID) {
      window.location.href = "/me/portal";
    }

    this.state = {
      consultationType: this.props.match.params.consultationType,
      checkoutSessionID,
      selectedProduct: getVisitProduct(checkoutSessionID) || "",
      showError: false,
    };

    if (!getVisitID(checkoutSessionID)) {
      window.location.href = "/me/portal";
    }
  }

  handleSelection = (selectedProduct) => {
    let modifiedProduct = selectedProduct;
    const { checkoutSessionID } = this.state;

    if (isFollowUpVisit(checkoutSessionID)) {
      switch (selectedProduct) {
        case ORDER_TYPE_PROP_2_PACK:
          modifiedProduct = ORDER_TYPE_PROP_2_PACK_FOLLOW_UP;
          break;

        case ORDER_TYPE_PROP_1_PACK:
          modifiedProduct = ORDER_TYPE_PROP_1_PACK_FOLLOW_UP;
          break;
      }
    }

    this.setState({ selectedProduct: modifiedProduct, showError: false });
    setVisitProduct(modifiedProduct, checkoutSessionID);
    setConsultationTypeOrderItem(
      this.state.consultationType,
      modifiedProduct,
      checkoutSessionID,
    );
  };

  nextQuestion = () => {
    if (!isMailOrderBBOrderType(this.state.selectedProduct)) {
      this.setState({ showError: "true" });
      return;
    }
    setConsultationTypeOrderItem(
      this.state.consultationType,
      this.state.selectedProduct,
      this.state.checkoutSessionID,
    );

    this.props.history.push(
      `/visits/${this.state.consultationType}/select-flavored?checkoutSessionID=${this.state.checkoutSessionID}`,
    );
    window.scrollTo(0, 0);

    // Use this when scopolamine addon is ready
    // this.props.history.push(`/visits/${this.state.consultationType}/sca?checkoutSessionID=${this.state.checkoutSessionID}`);

    // window.scrollTo(0, 0);
  };

  isSelected = (selectedProduct) => {
    return this.state.selectedProduct === selectedProduct;
  };

  render() {
    const { classes } = this.props;

    const { bbName } = getBBProductDetails(this.state.checkoutSessionID);

    return (
      <div
        className={classes.container}
        style={{ backgroundColor: COLOR_KICK_BLUE }}
      >
        <GridContainer justifyContent="center">
          <GridItem xs={10} sm={10} md={8}>
            <h3
              style={{
                color: "#FFFFFF",
                fontFamily: "Spectral-SemiBold",
                fontSize: "32px",
                marginTop: "40px",
              }}
            >
              How many packs of beta-blockers would you like?
            </h3>
            <p
              style={{
                color: "#FFFFFF",
                fontFamily: "BasisGrotesquePro-Regular",
                fontSize: "18px",
                lineHeight: "26px",
                // letterSpacing: "-0.21px"
              }}
            >
              Your preference will be shared with your doctor to determine the
              best treatment plan.
              <br />
            </p>
          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <Card className={classes.cardConsultation}>
              <CardBody
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "0 2px",
                }}
              >
                <div
                  className={classes.selectBBProductWrapper}
                  style={{
                    overflow: "hidden",
                    backgroundColor:
                      this.isSelected(ORDER_TYPE_PROP_2_PACK) ||
                      this.isSelected(ORDER_TYPE_PROP_2_PACK_FOLLOW_UP)
                        ? "#fff7e5"
                        : "",
                  }}
                  onClick={() => this.handleSelection(ORDER_TYPE_PROP_2_PACK)}
                >
                  <img
                    className="imgTwoPack"
                    src={imgTwoPack}
                    style={{
                      height: "fit-content",
                      position: "relative",
                      marginBottom: "10px",
                    }}
                    alt={`Double Pack ${bbName} (48 tablets)`}
                  />
                  <div className={classes.selectBBProductTwoPackWrapper}>
                    <h4
                      className={classes.selectBBProductImageTitle}
                      style={{
                        marginBottom: 0,
                        color: kickBlue,
                        fontWeight: "bold",
                      }}
                    >
                      Two Packs {bbName} (48 Tablets)
                    </h4>
                    <p
                      style={{
                        fontSize: "16px",
                        // textAlign: "center",
                        color: kickRed,
                        fontWeight:
                          this.isSelected(ORDER_TYPE_PROP_2_PACK) ||
                          this.isSelected(ORDER_TYPE_PROP_2_PACK_FOLLOW_UP)
                            ? "bold"
                            : "",
                      }}
                    >
                      {getFollowUpOrOriginalPrice(
                        ORDER_TYPE_PROP_2_PACK,
                        isFollowUpVisit(this.state.checkoutSessionID),
                      )}{" "}
                      - Medication with FREE Shipping
                      <br />
                      <span
                        style={{
                          // textAlign: "center",
                          fontSize: "15px",
                          color: kickNavy,
                        }}
                      >
                        {" "}
                        Most Popular Option
                      </span>
                    </p>

                    <ul
                      style={{
                        fontSize: "18px",
                        color: kickNavy,
                        lineHeight: "140%",
                      }}
                    >
                      <li style={{ paddingBottom: "2px" }}>
                        Always be prepared with a pack at home and another at
                        work.
                      </li>
                      <li style={{ paddingBottom: "2px" }}>
                        Two-pack refills without needing a new prescription.
                      </li>
                      <li style={{ paddingBottom: "2px" }}>
                        Your order lasts longer, so you can refill less often.
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  style={{
                    height: "1px",
                    margin: "0 100px",
                    backgroundColor: COLOR_KICK_BLUE,
                  }}
                />

                <div
                  className={classes.selectBBProductWrapper}
                  style={{
                    backgroundColor:
                      this.isSelected(ORDER_TYPE_PROP_1_PACK) ||
                      this.isSelected(ORDER_TYPE_PROP_1_PACK_FOLLOW_UP)
                        ? "#fff7e5"
                        : "",
                  }}
                  onClick={() => this.handleSelection(ORDER_TYPE_PROP_1_PACK)}
                >
                  <img
                    src={imgOnePack}
                    style={{
                      height: "fit-content",
                      marginBottom: "10px",
                      position: "relative",
                    }}
                    alt={`Single Pack ${bbName} Tablets`}
                  />
                  <h4
                    className={classes.selectBBProductImageTitleLower}
                    style={{
                      fontWeight:
                        this.isSelected(ORDER_TYPE_PROP_1_PACK) ||
                        this.isSelected(ORDER_TYPE_PROP_1_PACK_FOLLOW_UP)
                          ? "bold"
                          : "",
                    }}
                  >
                    One Pack {bbName} (24 tablets)
                    <br />
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight:
                          this.isSelected(ORDER_TYPE_PROP_1_PACK) ||
                          this.isSelected(ORDER_TYPE_PROP_1_PACK_FOLLOW_UP)
                            ? "bold"
                            : "",
                      }}
                    >
                      {getFollowUpOrOriginalPrice(
                        ORDER_TYPE_PROP_1_PACK,
                        isFollowUpVisit(this.state.checkoutSessionID),
                      )}{" "}
                      — Medication with FREE Shipping
                    </p>
                  </h4>
                </div>
              </CardBody>
            </Card>
            <div style={{ color: "red", margin: "20px auto 6px auto" }}>
              <p style={{ textAlign: "center" }}>
                {this.state.showError ? "Please select an option above" : ""}
              </p>
            </div>
            <Button
              onClick={() => {
                trackVisitProductSelected(
                  getVisitID(this.state.checkoutSessionID),
                  this.state.selectedProduct,
                );
                this.nextQuestion();
              }}
              style={{
                display: "block",
                backgroundColor: "#F25930",
                margin: "4px auto 30px auto",
                width: "300px",
                fontSize: "18px",
                fontWeight: "medium",
                textTransform: "unset",
              }}
            >
              Continue
            </Button>
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  componentDidMount() {
    this.visitIDCheckPoller = setInterval(() => {
      if (!getVisitID(this.state.checkoutSessionID)) {
        window.location.href = "/me/portal";
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.visitIDCheckPoller);
  }
}

SelectBBProduct.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(consultationStyles)(SelectBBProduct);
